/* Animated Stats — counts numbers up when scrolled into view */
if (!customElements.get('animated-stats')) {
  class AnimatedStats extends HTMLElement {
    constructor() {
      super();
      this.numbers = Array.from(this.querySelectorAll('.stats__number'));
      this.hasRun = false;
    }

    connectedCallback() {
      if (this.numbers.length === 0) return;

      if (!('IntersectionObserver' in window)) {
        // No observer support — just show final values
        this.numbers.forEach((el) => this._setFinal(el));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasRun) {
            this.hasRun = true;
            this.numbers.forEach((el) => this._animate(el));
            observer.disconnect();
          }
        });
      }, { threshold: 0.35 });

      observer.observe(this);
    }

    _setFinal(el) {
      const target = parseFloat(el.dataset.target) || 0;
      el.textContent = (el.dataset.prefix || '') + this._format(target) + (el.dataset.suffix || '');
    }

    _animate(el) {
      const target = parseFloat(el.dataset.target) || 0;
      const prefix = el.dataset.prefix || '';
      const suffix = el.dataset.suffix || '';
      const duration = 1600; // ms
      const start = performance.now();

      const step = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        // easeOutCubic for a nice deceleration
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = target * eased;
        el.textContent = prefix + this._format(current, target) + suffix;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = prefix + this._format(target) + suffix;
        }
      };
      requestAnimationFrame(step);
    }

    _format(value, target) {
      // If the target is a whole number, show integers during animation
      const t = target !== undefined ? target : value;
      if (Number.isInteger(t)) {
        return Math.round(value).toLocaleString();
      }
      // else keep one decimal
      return (Math.round(value * 10) / 10).toLocaleString();
    }
  }
  customElements.define('animated-stats', AnimatedStats);
}
